// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> chesapeake-pointe
// Generated: 2026-10-22T20:07:43.354Z
// Counts: 1 design, 68 content, 59 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments for Rent in Chesapeake , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Chesapeake Pointe, where comfort meets convenience in the heart of Chesapeake, VA. With spacious one, two, and three-bedroom floor plans, life here flows effortlessly. Immerse yourself in local culture with attractions like the Chesapeake Arboretum, Historic Norfolk, and Tidewater Community College, all just moments from your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in vibrant <a href=\"https://www.livechesapeakepointe.com/neighborhood/\">Chesapeake, VA</a>, our pet-friendly community seamlessly blends comfort and convenience. Choose from spacious one to three-bedroom floor plans, enjoy a refreshing swim, or unwind at the yoga studio. With resident activities and a playground, there's something for everyone. Join us and elevate your lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in vibrant Chesapeake, VA, you’ll find a variety of floor plans, from cozy one-bedrooms to spacious three-bedrooms, perfect for any lifestyle. Enjoy an array of amenities, including a refreshing swimming pool, dog park, fitness center, and resident activities. Lease your new home online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in Chesapeake, VA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Each space is crafted for comfort and convenience. Have questions? Our leasing team is eager to assist you—reach out today and let’s make your new home a reality!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in vibrant Chesapeake, VA, our diverse floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious three-bedroom residences, each layout offers comfort and style. Uncover the perfect apartment home tailored just for you—browse our available floor plans today and embrace your new beginning!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in Chesapeake, VA, picture the perfect blend of comfort and community. Choose from spacious <a href=\"https://www.livechesapeakepointe.com/floor-plans/\">one to three-bedroom floor plans</a>, all while enjoying amenities like a sparkling swimming pool, fitness center, and inviting dog park. Join us and embrace a lifestyle of relaxation and engagement!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Chesapeake Pointe, where spacious one, two, and three-bedroom floor plans meet a vibrant community. Nestled in Chesapeake, VA, enjoy nearby attractions such as the serene Chesapeake Arboretum, the educational Children's Museum of Virginia, and the beautiful Oak Grove Lake Park. Your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Chesapeake , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $350 per pet, and monthly pet rent is $50 per pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit in a great location in Chesapeake Virginia, with a <a href=\"https://www.livechesapeakepointe.com/floor-plans/\">one, two, or three bedroom apartment</a> at Chesapeake Pointe. This pet-friendly community features amenities designed to simplify your life and a friendly vibe that will make you feel welcome from day one. Our spacious floor plans have been upgraded for your style and comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in charming Chesapeake, VA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Maximize your convenience—log into our resident portal to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience. Welcome home to comfort and community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chesapeake Pointe in beautiful Chesapeake, VA, our versatile floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—accommodate every lifestyle. Experience the vibrant community that our residents love by scheduling a tour today. Let their testimonials inspire your new beginning at Chesapeake Pointe!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Chesapeake Pointe in beautiful Chesapeake, VA! With thoughtfully designed one, two, and three-bedroom apartments, we cater to your unique lifestyle. Stay tuned for our team to connect—exciting possibilities await you at your next home sweet home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Chesapeake Pointe in beautiful Chesapeake, VA! Our thoughtfully designed <a href=\"https://www.livechesapeakepointe.com/floor-plans/\">one, two, and three-bedroom apartments</a> offer comfort and style for every lifestyle. Take a virtual tour today and experience the inviting atmosphere and modern amenities that await you in your future home!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-bc81-76a9-af86-afcce4cff711.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom in a modern apartment with gray walls, a wooden headboard, striped bedding, and a window at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166313/019d0267-f02b-73e9-ad30-1d910b5b0176.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Chesapeake Pointe leasing office and management entrance, an on-site indoor amenity for residents."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166313/019d0267-f02b-73e9-ad30-1d910b5b0176.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Chesapeake Pointe leasing office and community entrance in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-b0f9-75ef-bc35-bd57dc89913e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright white apartment kitchen with granite countertops, white cabinets, stainless sink, and black appliances at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-d74e-71bd-a4b7-160e96c6d3d7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with tufted headboard bed, white bedding, wooden dresser, plant, and window with sheer curtains at Chesapeake Pointe, offers apartments in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166313/019fcdf3-bd9c-70ea-91d7-157a2778b403.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166313/019d0267-d612-702b-b5ff-b36a791bd4dc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of brick townhome buildings with manicured landscaping and clear blue skies."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Oak Grove Lake Park, a 65-acre park with a lakeside walking path near Chesapeake Pointe in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4d04-770a-8226-5776c3adb1fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Nauticus waterfront maritime museum near Chesapeake Pointe in the Hampton Roads area of Virginia."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-46b4-71be-8380-c0b5ce1c8be4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Chesapeake Arboretum forest trails and gardens near Chesapeake Pointe in Chesapeake, VA."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ed44-7223-8083-41a7e06c582f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a fenced apartment pool area with lounge chairs and orange umbrellas; a playground is nearby at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA"
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ed44-7223-8083-41a7e06c582f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a fenced apartment pool area with lounge chairs and orange umbrellas; a playground is nearby at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA"
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-f1c2-72bc-a432-9d1e6aed2eca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Colorful outdoor playground with slides and climbing structures in a shaded area at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA"
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166313/019d0267-c5f8-757a-b173-ebfe7b8506ba.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Welcome to the Dog Park sign with paw print"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$20"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_optional": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Yearly Pool Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10–$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": ""
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "300"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "50"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Starting at $500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "50% of monthly rent; starting at $500"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.washer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Washer/Dryer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$60"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0267-946a-72c8-b576-21f79f07e765.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living area of an apartment with a white sofa, armchair, coffee table, and dining set near a sliding door."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0267-c5da-74f2-924a-84c923c3e06f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-plan living room with dining area and small kitchen in a modern apartment."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fce68-55fc-70f3-a680-92c697d52357.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fce68-55b5-726f-817c-6f0b8265eee3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fce68-5624-7016-bfe3-aeee9de475e5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-269c-74a7-8c7c-cebbcd2037bb.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Starbucks"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi — a go-to for a morning cup or a mid-day break."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2eac-753b-b66f-05c1a806cd56.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Harris Teeter"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Large supermarket with full deli and bakery departments, fresh produce, and health & beauty aisles for everyday shopping runs."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Oak Grove Lake Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Outdoors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A 65-acre outdoor retreat with a 1.5-mile path circling the lake, shaded benches, and a playground — perfect for a daytime stroll."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1306-713e-9de7-39d233e489b8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Baker's Crust Artisan Kitchen"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dining & Brunch"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed New American kitchen serving breakfast, sandwiches, wood-fired pizzas and creative entrees — a favorite for a leisurely brunch."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4ea4-7139-8f28-952f32c2f55d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Chrysler Museum of Art"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Esteemed museum with a sweeping collection spanning ancient to contemporary art, including a renowned glass and sculpture gallery."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6826-730b-8ee4-9eaefeccccdd.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Dismal Swamp Canal Trail"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A flat, paved 11-mile trail for walking, biking and horseback riding, complete with a boat ramp and picnic area for an active day out."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-205d-743c-9f97-4d8a95c2cd5d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Towne Point Pub & Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed neighborhood pub pouring a wide beer selection with happy-hour specials, bar bites and karaoke nights."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4e98-7739-b0e0-478c6fd2d136.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The NorVa"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Downtown Norfolk's premier music venue hosting national indie and touring acts, with a general-admission floor and intimate balcony."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2563-7607-be4a-c57e1ab59934.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Butcher's Son"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Dark, stylish chophouse plating select organic steaks and seafood alongside craft beers and a Sunday brunch."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-12a5-720b-9b55-dbce5e401f74.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Winston's Cafe"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Late-Night"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Welcoming, casual hangout with classic and creative American eats, cocktails and live music that keep the evening going."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4150-74fd-8326-ce33e731fd77.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinemark Chesapeake Square and XD"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Multiscreen movie theater with stadium seating, XD auditoriums and self-service ticketing kiosks for an easy night at the movies."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-215a-7389-9825-91e9cc63c086.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "S & J Seafood"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Casual Eats"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual local spot specializing in fresh seafood for lunch and dinner — an easy grab when the evening runs late."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 26,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_05511fff-1d1b-435a-b7c9-f9d364414292",
      "custom_49b0dc33-723b-4d04-98a1-233fe98d027d",
      "custom_6f638cc1-db8a-478c-9ac9-b49cb6a86271",
      "custom_a8970b76-915e-481d-8b4e-d3dc91f235da",
      "custom_05b1545a-9589-417a-a323-f2304e41093d",
      "custom_c10cd6b4-75a2-405a-9e47-1ffd2d62debc",
      "custom_11397d14-312c-4402-8c05-c3e29bf70e64",
      "custom_f4636911-6838-420c-8b4d-4365b586339d",
      "custom_2757437b-f5c9-4b2a-b2e2-ac6ac86a9ac6",
      "custom_b759af81-6046-4e53-a3e1-610d6cc2f262",
      "custom_35c2a942-a74f-4501-a63e-d31264a45b44",
      "custom_3b7696dc-0d80-46cd-a5d9-543191c38586",
      "custom_dfd76d26-9944-4bf0-9f6d-aa2e157b0876",
      "custom_bcf6f81e-2a34-4b75-93f7-fa0a8dbf1250",
      "custom_517bc9d5-00ab-4772-a941-d00aec19f096",
      "custom_2725d80d-177c-4af9-bd16-1e392abe3144",
      "custom_a2921454-0e8e-4cca-870a-26c3921463a8",
      "custom_3efb47b7-aa94-4e26-87f7-989ea67c2fc4",
      "custom_d1a6e7b3-714d-4cf4-94fc-cffa4fd54c95",
      "custom_41e652ae-0d91-40bd-abc1-cacaa1803cc8"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
